export const UserMessages = {}

UserMessages[100] = "User successfully deleted."
UserMessages[101] = "Days successfully transferred"



UserMessages[300] = "User not found."
